import { useMutation, useQueryClient } from '@tanstack/react-query';
import { contractApi } from '@/features/contracts/api/contractApi';

/**
 * Récupère le récap de la future facture échéancier (dry-run).
 * Déclenché à l'ouverture de la modale via .mutate() — pas un useQuery pour
 * éviter un fetch automatique et un cache inutile.
 */
export const useInvoicePreview = (contractId: number | undefined) =>
  useMutation({
    mutationFn: () => {
      if (!contractId) throw new Error('contractId requis');
      return contractApi.regenerateMonthlyInvoice(contractId, true);
    },
  });

/**
 * Confirme la régénération : écrase le PDF en place. Invalide les détails
 * de paiement et la timeline d'audit pour refléter la mise à jour.
 */
export const useConfirmRegenerate = (contractId: number | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => {
      if (!contractId) throw new Error('contractId requis');
      return contractApi.regenerateMonthlyInvoice(contractId, false);
    },
    onSuccess: () => {
      if (!contractId) return;
      queryClient.invalidateQueries({ queryKey: ['payment-details', contractId] });
      queryClient.invalidateQueries({ queryKey: ['contract-audit-logs', contractId] });
    },
  });
};
